import { baseTokens } from '../base';
import { TenantTokens } from '../types';

/**
 * Wallace Real Estate Brand Tokens
 *
 * Colors sourced from email template (server/src/services/report/wallace/styles.ts)
 * Brand identity: Sophisticated, approachable, modern
 * Tagline: "Think. Feel. Sold."
 */
export const wallaceTokens: TenantTokens = {
  ...baseTokens,
  colors: {
    primary: {
      main: '#00453D', // Dark green - headers, footer, primary actions
      light: '#1A5E55', // Lighter for hover states
      dark: '#003530', // Darker variant
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#75C485', // Light green - accent bar, links, chart bars
      light: '#8DD19A', // Mid green for gradients
      dark: '#5BA86B',
      contrastText: '#000000',
    },
    background: {
      default: '#F5F0ED', // Cream/Isabelline - main app background
      paper: '#FFFFFF', // Cards, dialogs
      subtle: '#FAFAFA', // Table rows, subtle surfaces
    },
    divider: '#C9C7C7', // Border gray for dividers
    text: {
      primary: '#333333', // Main text
      secondary: '#7A7A7A', // Sonic silver - secondary text
      disabled: '#C9C7C7', // Chinese silver
    },
    success: { main: '#75C485', light: '#9DD4A8', dark: '#5BA86B' },
    warning: { main: '#ED6C02', light: '#FF9800', dark: '#E65100' },
    error: { main: '#F44336', light: '#EF5350', dark: '#C62828' },
    info: { main: '#00453D', light: '#75C485', dark: '#003530' },
  },
  branding: {
    logo: '/logos/wallace.png',
    logoAlt: 'Wallace Real Estate',
    favicon: '/assets/favicons/wallace.ico',
  },
};
